export default function () {
  const tiles_section = document.getElementById("rolmTiles");
  const tiles = document.querySelectorAll(".rolmT");
  const content_section = document.getElementById("tOuterWrap");
  const interior_content_sections = document.querySelectorAll(".tOSection");
  const close = document.querySelector(".headerClose");
  const interior_button_instructions = document.getElementById('widget-instructions');

  if (tiles) {
    tiles.forEach((tile) => {
      tile.addEventListener("click", function () {
        //hide the selection tiles
        tiles_section.classList.add("hidden");
        //show the general content area container
        content_section.classList.add("active");
        //show the specific content area that was selected
        let activate_inner_section = document.querySelector(
          ".tOSection." + tile.dataset.class
        );
        activate_inner_section.classList.add("active");
        //activate the first interior button
        let first_button = document.querySelector(
          "." + tile.dataset.class + " .tOBtn:first-of-type"
        );
        first_button.classList.add("active");
        //active the first interior content section
        let first_section = document.querySelector(
          "." + tile.dataset.class + " .tOWrapper:first-of-type"
        );
        first_section.classList.add("active");

        //set the interior button instructions class to get the correct color for the section
        interior_button_instructions.className = 'headerMessage ' + tile.dataset.class;
      });

      //get the interior buttons of the section clicked
      let interior_buttons = document.querySelectorAll(
        "." + tile.dataset.class + " .tOBtn"
      );

      //bind the click function logic to the interior buttons
      interior_buttons.forEach((interior_button) => {
        interior_button.addEventListener("click", function () {
          clickInteriorButton(this, interior_buttons);
        });
      });
    });
  }

  if (close) {
    close.addEventListener("click", function () {
      //show main selection tiles again
      tiles_section.classList.remove("hidden");
      //hide parent content section area
      content_section.classList.remove("active");
      //hide all interior content sections, clearing the main area
      interior_content_sections.forEach((interior_content_section) => {
        interior_content_section.classList.remove("active");
      });
    });
  }

  function clickInteriorButton(clicked_interior_button, interior_buttons) {
    //remove active class from all interior buttons
    interior_buttons.forEach((interior_button) => {
      interior_button.classList.remove("active");
    });
    //add active class to clicked button
    clicked_interior_button.classList.add("active");
    //remove active class from all interior content areas
    let interior_content_areas = document.querySelectorAll(".tOWrapper");
    interior_content_areas.forEach((interior_content_area) => {
      interior_content_area.classList.remove("active");
    });
    //Traverse up dom twice to get parent container in which to find the next interior clicked item (so it doesn't find interior sections from other tile categories)
    let parent_container = clicked_interior_button.parentElement.parentElement;
    let clicked_content_area = parent_container.querySelector('.tOWrapper[data-policynum="' + clicked_interior_button.dataset.policynum + '"]')
    clicked_content_area.classList.add('active');
    // alert(clicked_interior_button.dataset.policynum);
  }
}
